import React from "react";
import { StyleSheet, View } from "react-native";
import Colors from "@microdoing/shared/constants/Colors";

const styles = StyleSheet.create({
  separatorLine: {
    width: "100%",
    borderBottomWidth: 1,
    borderColor: Colors.whiteGrey,
    marginVertical: 10,
  },
});

interface Props {}

const SeparatorLine = ({}: Props) => {
  return <View style={styles.separatorLine} />;
};

export { SeparatorLine };
